import type { FaireProductEntity } from "../../entity_types/product";

export const p_t9ubbgv7jn: FaireProductEntity = {
  token: "p_t9ubbgv7jn",
  type: "product",
  name: "Gold Antler Sphere Stand",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/6631803a8b78e4a290e15114061c45dae588e79b77d859c57b5f5cdf0b898042.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6972be30dc9ebb69c1ac262ca955aa1d71793a2d64f8eb27e1588b7c23895f91.jpeg",
    "https://cdn.faire.com/fastly/7f85b77bf90115ffd84186f3db0631e79b3f1636b578c89813e99f6a069af3c7.jpeg",
    "https://cdn.faire.com/fastly/47e0930dda2c66c8d890a152ed83ee932e3bcde08b5d702585d690eb8513cd55.jpeg",
    "https://cdn.faire.com/fastly/1bfefd45d441c49c16acbaea57350422830795d389506b00028b173e7559ffdd.jpeg",
  ],
  priceDollars: 6,
  description:
    '\nThis listing is for ONE Gold Antler Sphere Stand\n\nSize: approximately 3.25"\n\nCan safely hold spheres up to 5" diameter\n\n*spheres shown in photos are for size reference only and are sold separately \n\nSHIPPING CALCULATED AFTER CHECKOUT\n',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:33.506Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
